<template>
  <div>
    <div class="craft">
      <div class="part-one">
        <div class="base-title">
          <div class="part-one-content">
            <img
              class="part-one-title-img"
              src="../assets/imgs/craft/part-1-title.png"
              alt=""
            />
            <div class="part-text part-one-title" style="margin-left: 0rem">
              为鼓励高校大学生来蓉留蓉发展，支持海内外高校毕业生（灵活就业人员）在蓉灵活缴存住房公积金，享受低息贷款、缴存补贴、个税扣除等待遇保障。
            </div>
          </div>
        </div>
      </div>
      <div class="part-two">
        <img
          src="../assets/imgs/24/part-2-title.png"
          class="part-two-title-img"
        />
        <div class="part-two-content">海内外高校毕业生。</div>
      </div>
      <div class="part-three">
        <img
          src="../assets/imgs/24/part-3-title.png"
          class="part-two-title-img"
        />
        <!-- <div class="part-title part-four-title">
                    灵活缴存人可通过“成都公积金”、“天府市民云”手机APP等线上渠道，通过人脸识别完成缴存身份实名认证，签订《成都市灵活就业人员参加住房公积金制度协议》，即可完成账户设立，并通过微信、支付宝等方式进行线上灵活缴存。
                </div> -->
        <div class="part-three-content">
          <p class="part-three-content-item">
            灵活缴存人可通过“成都住房公积金”“天府市民云”手机APP等线上渠道，通过人脸识别完成缴存身份实名认证，签订《成都市灵活就业人员参加住房公积金制度协议》，即可完成账户设立，并通过微信、支付宝等方式进行线上灵活缴存。
          </p>
        </div>
      </div>
      <div class="part-four">
        <img
          src="../assets/imgs/24/part-4-title.png"
          class="part-two-title-img"
        />
        <div class="main-content">
          <div class="part-four-items">
            （一）缴存时间自由灵活，可7×24小时缴款。
          </div>
        </div>
        <div class="main-content">
          <div class="part-four-items">
            （二）缴款方式自主灵活。缴存人可结合自身收入或需要，自主确定缴存时间和频率，没有按月、定额缴存的限制。最低缴存金额为全市月最低工资标准×最低缴存比例，目前为99元；下限以上，缴存金额可随时调整。
          </div>
        </div>
      </div>
      <div class="part-four">
        <img
          src="../assets/imgs/24/part-5-title.png"
          class="part-two-title-img"
        />
        <div class="main-content">
          <div class="part-four-items">
            （一）购房时可申请公积金贷款。目前首套个人住房公积金贷款5年以上利率为2.85%。
          </div>
        </div>
        <div class="main-content">
          <div class="part-four-items">
            （二）缴存资金按照中国人民银行规定的住房公积金账户存款利率计息，储存时间达到6个月（含）以上的缴存资金可以进行提取。
          </div>
        </div>
        <div class="main-content">
          <div class="part-four-items">
            （三）缴存账户中存储时间满一年的资金，每年给予
            0.5%—1%的缴存补贴，目前为0.75%。
          </div>
        </div>
        <div class="main-content">
          <div class="part-four-items">
            （四）缴存资金可按规定纳入个税扣除。
          </div>
        </div>
      </div>
      <div class="contact">
        <img
          class="top"
          src="./../assets/imgs/24/part-5-tittle-add.png"
          alt=""
        />
        <div class="content">全年。</div>
      </div>
      <div class="contact">
        <img class="top" src="./../assets/imgs/24/part-6-tittle.png" alt="" />
        <div class="content">
          <div class="number">
            <span class="label">政策咨询电话：</span>
            <div><a href="tel:028-61889897">028-61889897</a></div>
            <div>
              <a href="tel:028-12329">028-12329</a>
              <span style="font-size: 13px"> (7*24小时公积金热线)</span>
            </div>
            <div><a href="tel:028-61889924">028-61889924</a></div>
          </div>
          <div class="unit">
            <span class="label">责任单位：</span>
            成都住房公积金管理中心
          </div>
        </div>
      </div>
      <!-- <div class="part-five">
        <div style="position: relative">
          <img src="../assets/imgs/24/code-1.png" alt="" /><img
            style="
              width: 1.94rem;
              height: 1.94rem;
              position: absolute;
              top: 0;
              left: 0;
            "
            src="../assets/imgs/24/code-1-1.png"
            alt=""
          />
        </div>
        <div style="position: relative">
          <img src="../assets/imgs/24/code-2.png" alt="" /><img
            style="
              width: 1.94rem;
              height: 1.94rem;
              position: absolute;
              top: 0;
              left: 0;
            "
            src="../assets/imgs/24/code-2-1.png"
            alt=""
          />
        </div>
      </div> -->
    </div>
    <call
      site="https://wt.cdzfgjj.chengdu.gov.cn/download/download.html"
      phone="028-12329"
    ></call>
  </div>
</template>

<script>
// import bottom from '../components/bottom.vue'
import call from "../components/call.vue";

export default {
  name: "craft",
  components: {
    // bottom,
    call,
  },
  data() {
    return {
      part3: [
        {
          id: 1,
          title: require("../assets/imgs/craft/part3-1.png"),
          content: "可获一次性2万元奖励",
          boxHeight: "height:1.45rem",
        },
        {
          id: 2,
          title: require("../assets/imgs/craft/part3-2.png"),
          content: "按规定享受教育优待政策",
          boxHeight: "height:1.42rem",
        },
        {
          id: 3,
          title: require("../assets/imgs/craft/part3-3.png"),
          content: "凭卡享受医疗、交通、保险、文体娱乐等服务保障",
          boxHeight: "height:1.42rem",
        },
        {
          id: 4,
          title: require("../assets/imgs/craft/part3-4.png"),
          content:
            "还可享受人才落户、便捷就医、交通出行、身心健康、保险保障、学习交流等相关政策支持",
          boxHeight: "height:1.9rem;margin-bottom:0",
          text: "text-align: left;",
        },
      ],
      part4: [
        {
          id: 1,
          title: "title-bg",
          label: "推荐申报",
          content1: {
            title: "单位推荐：",
            text: "企事业单位工会负责组织开展，择优推荐1—2人（本单位内最优秀），并指导被推荐人填写《“成都工匠” 推荐审批表》。企事业单位工会负责将本单位申报人材料报送至所在区（市）县总工会",
          },
          content2: {
            title: "个人申报：",
            text: "个人申报需如实填写《“成都工匠”推荐审批表》（附件1），申报材料报送至所在区（市）县总工会进行初审，按照单位申报流程完成资格审核和公示。公示无异议后，由所在区（市）县总工会将其与单位申报人选一并推荐",
          },
          boxHeight: "height:5.5rem",
        },
        {
          id: 2,
          label: "资格审核",
          title: "title-bg title-bg2",
          content1: {
            title: "",
            text: "所在区（市）县总工会对申报对象进行初审、择优推荐至市总工会。市总工会对单位申报人员进行资格复核",
          },
          content2: "",
          boxHeight: "height:1.79rem",
        },
        {
          id: 3,
          label: "专家评审",
          title: "title-bg title-bg3",
          content1: {
            title: "",
            text: "专家评审小组进行现场评审，由评审专家从工匠精神、精湛技艺等方面，对候选人员、集体按百分制进行现场评审打分；召开综合评审会议，确定候选建议名单",
          },
          content2: "",
          boxHeight: "height:2.25rem",
        },
        {
          id: 4,
          label: "社会公示",
          title: "title-bg title-bg4",
          content1: {
            title: "",
            text: "",
          },
          content2: "",
          boxHeight: "height:0.3rem",
        },
        {
          id: 5,
          label: "领导小组审批",
          title: "title-bg title-bg5",
          content1: {
            title: "",
            text: "市总工会将 “成都工匠”候选人员名单提交市委人才工作领导小组审批",
          },
          content2: "",
          boxHeight: "height:1.35rem",
        },
        {
          id: 6,
          label: "命名表扬",
          title: "title-bg title-bg6",
          content1: {
            title: "",
            text: "",
          },
          content2: "",
          boxHeight: "height:0rem;border:none",
        },
      ],
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.craft {
  background: #0839b7;
  overflow: hidden;
  padding: 0.24rem 0.12rem;
  padding-bottom: 1.65rem;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  overflow-y: auto;

  p {
    line-height: 1.5;
  }

  .part-title {
    font-size: 0.26rem;
    //font-family:: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #333333;
    position: relative;

    &::before {
      position: absolute;
      content: "";
      width: 0.28rem;
      height: 0.28rem;
      border-radius: 50%;
      background: none;
      border: 0.06rem solid #ff6d60;
      box-sizing: border-box;
      top: 0.08rem;
      left: -0.2rem;
    }
  }

  .part-text {
    font-size: 0.26rem;
    //font-family:: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #4e4e4e;
    line-height: 0.44rem;
    text-align: left;
  }

  .part-one {
    width: 7.5rem;
    height: 6.7rem;
    margin: 0 auto;

    .base-title {
      width: 7.26rem;
      height: 5.6rem;
      background: url(../assets/imgs/24/base-title.png);
      background-size: 100% 100%;
      position: relative;

      .part-one-content {
        width: 6.85rem;
        // height: 3.8rem;
        background: #ffffff;
        border-radius: 10px;
        position: absolute;
        top: 4.02rem;
        left: 0.22rem;
        padding-left: 0.36rem;
        padding-right: 0.37rem;
        box-sizing: border-box;
        padding-bottom: 0.35rem;

        .part-one-title-img {
          position: absolute;
          top: -0.32rem;
          left: 0;
          width: 6.86rem;
          height: 1.12rem;
        }

        .part-one-title {
          margin-top: 0.98rem;
          text-align: left;
          margin-left: 0.34rem;
        }

        .part-one-text {
          margin-top: 0.16rem;
        }
      }
    }
  }

  .part-two-title-img {
    width: 7.03rem;
    height: 1.37rem;
    top: 0;
    left: -0.18rem;
    position: absolute;
  }

  .part-two {
    margin-left: 0.02rem;
    width: 6.85rem;
    background: #e8eeff;
    height: 3rem;
    border-radius: 10px;
    padding-left: 0.33rem;
    padding-right: 0.3rem;
    box-sizing: border-box;
    margin: 0 auto;
    margin-top: 0.55rem;
    border: 0.00001px solid transparent;
    position: relative;

    .part-two-title {
      text-align: left;
      margin-left: 0.33rem;

      &::before {
        position: absolute;
        content: "";
        width: 0.28rem;
        height: 0.28rem;
        border-radius: 50%;
        background: none;
        border: 0.06rem solid #ff6d60;
        box-sizing: border-box;
        top: 0.08rem;
        left: -0.35rem;
      }
    }

    .part-two-content {
      margin-top: 1.5rem;
      margin-bottom: 0.3rem;
      width: 6.22rem;
      height: 1rem;
      background: #ffffff;
      border-radius: 10px;
      box-sizing: border-box;
      padding: 0.34rem 0.24rem 0 0.25rem;
      font-size: 0.26rem;
      //font-family:: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #4e4e4e;
      line-height: 0.44rem;
      text-align: left;
    }
  }

  .part-three {
    width: 6.85rem;
    background: #e8eeff;
    border-radius: 10px;
    margin-left: 0.02rem;
    margin-top: 0.22rem;
    box-sizing: border-box;
    margin: 0 auto;
    margin-top: 0.22rem;
    border: 0.00001px solid transparent;
    position: relative;
    padding: 1.5rem 0.25rem 0 0.25rem;

    .part-four-title {
      text-align: left;
      margin-left: 0.35rem;
      font-weight: 500;

      &::before {
        position: absolute;
        content: "";
        width: 0.28rem;
        height: 0.28rem;
        border-radius: 50%;
        background: none;
        border: 0.06rem solid #ff6d60;
        box-sizing: border-box;
        top: 0.08rem;
        left: -0.38rem;
      }
    }

    .part-three-content {
      text-align: left;
      color: #4e4e4eff;
      font-size: 0.26rem;
      width: 6.35rem;
      background: #ffffff;
      border-radius: 10px;
      padding: 0.25rem;
      box-sizing: border-box;
      position: relative;
      margin-bottom: 0.52rem;
      // margin-top: 0.25rem;

      .part-three-content-tittle {
        font-size: 0.34rem;
        //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
      }

      .part-three-content-item {
        box-sizing: border-box;
        position: relative;
        margin-bottom: 0.15rem;
        font-size: 0.26rem;
        //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4e4e;
        line-height: 0.44rem;
        text-align: left;
      }
    }

    .out-link {
      position: absolute;
      font-size: 0.26rem;
      //font-family:: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #3d5aa3;
      bottom: 0.45rem;
      left: 0.25rem;
      text-align: center;
      text-decoration: none;
    }
  }

  .part-four {
    width: 6.85rem;
    background: #e8eeff;
    border-radius: 10px;
    margin-left: 0.02rem;
    margin-top: 0.22rem;
    box-sizing: border-box;
    margin: 0 auto;
    margin-top: 0.22rem;
    border: 0.00001px solid transparent;
    position: relative;
    padding: 1.44rem 0.25rem 0 0.25rem;
    padding-bottom: 0.35rem;

    .part-four-title {
      text-align: left;
      margin-left: 0.35rem;

      &::before {
        position: absolute;
        content: "";
        width: 0.28rem;
        height: 0.28rem;
        border-radius: 50%;
        background: none;
        border: 0.06rem solid #ff6d60;
        box-sizing: border-box;
        top: 0.08rem;
        left: -0.38rem;
      }
    }

    .main-content {
      margin-top: 0.1rem;
      width: 6.35rem;
      background: #ffffff;
      border-radius: 10px;
      box-sizing: border-box;
      padding-top: 0.5rem;
      padding-left: 0.35rem;
      padding-right: 0.31rem;
      padding-bottom: 0.2rem;

      .part-four-items {
        box-sizing: border-box;
        position: relative;
        margin-bottom: 0.15rem;
        font-size: 0.26rem;
        //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4e4e;
        line-height: 0.44rem;
        text-align: left;
      }

      .dot {
        position: absolute;
        left: -0.45rem;
        top: 0;
        width: 0.36rem;
        height: 0.36rem;
        text-align: center;
        background-color: #739bfe;
        font-size: 0.3rem;
        line-height: 0.44rem;
        color: #fff;
        border-radius: 50%;
        vertical-align: middle;
        z-index: 9999;
      }
    }
  }

  .part-five {
    margin: auto;
    margin-top: 0.25rem;
    width: 6.86rem;
    box-sizing: border-box;
    border-radius: 13px;
    margin-bottom: 0.32rem;
    background-color: #fff;
    padding: 0.35rem;
    text-align: left;

    img {
      width: 100%;
    }

    p {
      font-size: 0.26rem;
      color: #4e4e4eff;
    }

    a {
      font-size: 0.26rem;
      word-break: break-word;
      line-height: 1.5;
      display: inline-block;
    }
  }

  .bottom-info {
    font-size: 0.24rem;
    //font-family:: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #97a9d9;
  }
}
</style>
